import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import enTranslation from './locales/en.json' assert { type: 'json' };
import svTranslation from './locales/sv.json' assert { type: 'json' };

// Configure i18next
i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources: {
      en: {
        translation: enTranslation
      },
      sv: {
        translation: svTranslation
      }
    },
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',

    // Common namespace used around the full app
    ns: ['translation'],
    defaultNS: 'translation',

    keySeparator: '.',

    interpolation: {
      escapeValue: false // React already safes from XSS
    },

    // Detection options
    detection: {
      order: ['cookie', 'localStorage', 'navigator', 'htmlTag'],
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      caches: ['cookie', 'localStorage'],
      cookieOptions: {
        expires: new Date(Date.now() + 365 * 24 * 60 * 60 * 1000), // 1 year from now
        domain: typeof window !== 'undefined' ? window.location.hostname : undefined,
        secure: typeof window !== 'undefined' ? window.location.protocol === 'https:' : false,
        sameSite: 'lax'
      }
    }
  });

export default i18n;
